import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Container, Element, Section } from 'react-bulma-components'
import { setTranslations } from 'react-i18nify'
import Layout from '../../components/layout/layout'
import { Translate } from '../../utils/translations'
import { campaign } from '..'

/**
 * Advice matching the self-reported inspection result.
 *
 * A defective gate sends the reader to a Decathlon store for a full refund; a
 * sound one tells them they may keep using the product. Both texts come from
 * the outcome rows of the translations sheet.
 *
 * The result lives in the URL rather than in component state so that reloading
 * or sharing the page still shows the right advice.
 */
const SimondOutcomePage: React.FC = () => {
  setTranslations(campaign.presentationLocales)
  const { lang, outcome } = useParams()

  if (outcome !== 'ok' && outcome !== 'nok') {
    return <Navigate to={`/${lang}`} replace />
  }

  const isDefective = outcome === 'nok'

  return (
    <Layout>
      <Element className="simond">
        <Section>
          <Container className="simond__column simond__column--narrow">
            <Element
              className={`simond__outcome-card simond__outcome-card--${outcome}`}
              data-testid="outcome-card"
              data-outcome={outcome}
            >
              <Element className="simond__outcome-icon" aria-hidden="true">
                {isDefective ? '✗' : '✓'}
              </Element>

              <Element className="simond__outcome-body" data-testid="outcome-body">
                <Translate value={`outcome.${outcome}.body`} />
              </Element>
            </Element>

            {isDefective && (
              <Element className="simond__support" mt={5} data-testid="support-note">
                <Translate value="outcome.nok.support" />
              </Element>
            )}
          </Container>
        </Section>
      </Element>
    </Layout>
  )
}

export default SimondOutcomePage
